<template>
    <div class="about">
        <div class="aboutUS">
            <div id="head">
                <div class="text">
                    <span class="text1">您的诉求，是我们的追求</span><br>
                    <span class="text2">音书无障碍服务沟通平台</span>
                </div>
            </div>
            <div id="company">
                <span class="title">关于公司</span><br>
                <img src="../assets/about/underline_2x.png" style="width:40%;">
                <p>广州音书科技有限公司是一家国家级高新技术企业，致力于通过互联网+人工智能技术改善听力言语障碍群体的沟通现状，并打造听力言语障碍群体的服务平台。目前已对外提供数亿次辅助沟通服务。</p>
                <p>音书科技通过为学校、政务服务中心、医院、银行、博物馆、图书馆等公共服务机构提供无障碍沟通解决方案，帮助听障人士更好地融入社会生活。同时，音书科技还上线了音书APP，为百万听障用户搭建起服务平台，并研发音书手表等产品帮助他们更高效地与外界交流。</p>
                <p>截止到目前，音书科技已经服务了超过100家公共服务机构和100万听障用户，音书已经成为听障人士与外界对话的重要纽带。</p>
                <span id="join" style="cursor: pointer;" @click="openUrl('https://www.zhipin.com/gongsir/4bf2213be61e308d1nd509u_EQ~~.html?ka=company-jobs')">加入我们</span>
            </div>
            <div style="width:90%;">
                <span class="title">发展历程</span><br>
                <img src="../assets/about/underline_2x.png" style="width:40%;">
                <div id="develop">
                    <!-- <img class="bgPic" src="../assets/about/develop@2x.png"> -->
                    <el-timeline>
                        <el-timeline-item v-for="(activity, index) in activities"
                        :key="index" type="success" color="white" size="large">
                            <div class="timeline">
                                <span>{{activity.timestamp}}</span>
                                <span style="text-align:left;">{{activity.content}}</span>
                                <img :src='activity.picSrc'>
                            </div>
                        </el-timeline-item>
                    </el-timeline>
                </div>
            </div>
            <div style="width:55%">
                <span class="title">团队介绍</span><br>
                <img src="../assets/about/underline_2x.png" style="width:40%; margin-bottom:2%;">
                <div id="team" v-for="(mem, index) in members" :key="index">
                    <img :src="mem.pic" style="width:30%;">
                    <div style="width:60%">
                        <span class="text1">{{mem.name}}</span><br>
                        <span class="text2">{{mem.desc}}</span>
                    </div>
                </div>
            </div>
            <div style="width:55%; margin-top:5%;" id="contact-box">
                <span class="title">联系我们</span><br>
                <img src="../assets/about/underline_2x.png" style="width:40%;">
                <div id="contact" style="margin-top:2%;">
                    <div id="contact1">
                        <div>
                            <img src="../assets/about/dianhua_2x.png">
                            <a href="https://tccc.qcloud.com/web/im/chat/?webAppId=3941632bfd3545b0d16fd30339f49f7f" target="_blank"><span>点击立刻在线沟通</span>
                            </a>
                        </div>
                        <div>
                            <img src="../assets/about/zhuanshufensi_2x.png">
                            <span>商务合作邮箱：bd@voibook.com</span>
                        </div>
                    </div>
                    <!-- <div id="contact2">
                        <div>
                            <img src="../assets/about/zhuanshufensi_2x.png">
                            <span>粉丝QQ群：663559320</span>
                        </div>
                        <div>
                            <img src="../assets/about/webicon306_2x.png">
                            <span>商务合作QQ：1956033634</span>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
        <myFooter></myFooter>
				<customer-service />
    </div>
</template>

<script>
import bus from '@/lib/bus.js'
import CustomerService from '@/components/CustomerService.vue'

export default {
	name: 'aboutPage',
  components: {
    CustomerService
  },
	data () {
		return {
			activities: [
				{
					content: '获评国家高新技术企业',
					timestamp: '2022.12',
					picSrc: require('../assets/about/gongsi_2x.png')
				},
				{
					content: '获得智能科技开放产业基金驰星创投战略投资',
					timestamp: '2021.2',
					picSrc: require('../assets/about/shouji_2x.png')
				},
				{
					content: '获得种子轮投资',
					timestamp: '2017.4',
					picSrc: require('../assets/about/shinshophezuo_2x.png')
				},
				{
					content: '广州音书科技有限公司注册成立',
					timestamp: '2016.7',
					picSrc: require('../assets/about/gongsi_2x.png')
				},
				{
					content: '团队入驻华南理工大学创业基地，项目正式落地',
					timestamp: '2016.4',
					picSrc: require('../assets/about/bangong_2x.png')
				}
			],
			members: [
				{
					pic: require('../assets/about/zfg.jpg'),
					name: '曾凡钢院士，首席顾问',
					desc: `美国工程院外籍院士，教育部长江学者评审员;
								加州大学尔湾分校听觉研究中心主任;
								美国国立卫生院（NIH)重点项目评审；
								创办和投资六家中美高科技公司`
				},
				{
					pic: require('../assets/about/scc.png'),
					name: '石城川，CEO',
					desc: `2023年世界互联网大会“全球青年领军者”；
									复旦大学MBA；
									曾荣获福布斯亚洲“30Under30”和卡地亚CWI“多元、平等和包容性奖”；
									熟悉听力行业和言语康复行业；
									立志实现听障人士实现无障碍沟通；
									负责公司战略规划`
				},
				{
					pic: require('../assets/about/cgq.png'),
					name: '陈国强，技术合伙人',
					desc: `2020福布斯亚洲30 Under 30；
								华南理工大学软件工程硕士；
								从事机器学习算法研究；
								2014全国数学模型比赛一等奖；
								2016全国移动终端设计大赛冠军；
								负责公司技术研发`
				},
				{
					pic: require('../assets/about/wfy.png'),
					name: '王飞扬，市场合伙人',
					desc: `曾任深圳某重点中学在编物理教师；
								浙江大学硕士；
								立志通过AI赋能教育行业；
								户外运动爱好者，多次横渡钱塘江；
								负责公司市场推广`
				},
				{
					pic: require('../assets/about/psq.png'),
					name: '彭驷庆，产品合伙人',
					desc: `毕业于华南理工大学工控系；
								二次创业者；
								多年外企市场营销经验；
								熟悉互联网产品及工业品营销模式；
								负责公司产品研发`
				}
			]
		}
	},
	methods: {
		openUrl (url) {
				window.open(url, '_blank')
		}
	},
	mounted () {
		bus.$emit('changeSelectedIndex', 3)
		if (this.$route.params.anchor !== 'none') {
			location.href = '#' + this.$route.params.anchor
		} else {
			if (document.documentElement) {
				document.documentElement.scrollTop = 0
			} else {
				document.body.scrollTop = 0
			}
		}
	}
}
</script>

<style scoped>
@import './about.css';
</style>



// WEBPACK FOOTER //
// src/pages/About.vue